import modelsResolver from 'utils/api/models/utils/modelsResolver';
import { SingleSubscriberProduct, SubscriberDetails } from './singleSubscriberProduct';
import { AccountType } from 'utils/api/models/accounts/accountType';
import { tariffPlan } from 'utils/api/models/utils/tariffPlan';

export type SubscriberProducts = {
	_products: any;
	products: SingleSubscriberProduct[];
	subscriberDetail: SubscriberDetails;
	tariffPlan: (accountType: AccountType) => undefined | SingleSubscriberProduct;
};

const model: any = {
	_products: ['response', []],
	products: (model: SubscriberProducts) =>
		model._products.data.productDataList.map((singleSubscriberProduct: any) =>
			modelsResolver(singleSubscriberProduct, 'singleSubscriberProduct')
		),
	subscriberDetail: (model: SubscriberProducts) => model._products.data.subscriberDetail,
	tariffPlan: function(model: SubscriberProducts) {
		return (accountType: AccountType) => tariffPlan(model.products, 'groupId', accountType);
	},
};

export default model;
